import { render, staticRenderFns } from "./DetailRecAoVme.vue?vue&type=template&id=2b4566e9&"
import script from "./DetailRecAoVme.vue?vue&type=script&lang=js&"
export * from "./DetailRecAoVme.vue?vue&type=script&lang=js&"
import style0 from "./DetailRecAoVme.vue?vue&type=style&index=0&id=2b4566e9&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4566e9')) {
      api.createRecord('2b4566e9', component.options)
    } else {
      api.reload('2b4566e9', component.options)
    }
    module.hot.accept("./DetailRecAoVme.vue?vue&type=template&id=2b4566e9&", function () {
      api.rerender('2b4566e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/DetailRecAoVme.vue"
export default component.exports